import styled, { css } from 'styled-components';

export const StyledButton = styled.button`
  /* Default CTA dimensions chosen to match screenshot measurements */
  /* Default: 44px tall for hero CTAs (explicit pixel value for determinism) */
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.theme.typography.sizes.md};
  font-weight: ${props => props.theme.typography.weights.semibold};
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease, box-shadow 120ms ease;

  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.accent};
    outline-offset: 2px;
  }

  ${({ $variant, theme }) => $variant === 'primary' && css`
    background: ${theme.palette.accent};
    color: #FFFFFF;
    box-shadow: 0 18px 30px rgba(44, 123, 229, 0.25);

    &:hover {
      background: ${theme.palette.accentHover};
      box-shadow: 0 20px 34px rgba(28, 100, 242, 0.28);
    }
  `}

  ${({ $variant, theme }) => $variant === 'secondary' && css`
    background: #FFFFFF;
    color: ${theme.palette.accent};
    border-color: ${theme.palette.borderMuted};

    &:hover {
      border-color: ${theme.palette.accent};
      color: ${theme.palette.accentHover};
      box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
    }
  `}

  ${({ $size, theme }) => $size === 'small' && css`
    /* Header CTA captured at 40px tall */
    height: 40px;
    padding: 0 14px;
    border-radius: 9px;
    font-size: ${theme.typography.sizes.sm};
    box-shadow: none;
  `}
`;